// @flow

import type { Action } from './store.type';
import { ThemesType } from 'src/models/theme-setup';

export const SI_CHECK_THEME_STATUS_REQUEST = 'SI_CHECK_THEME_STATUS_REQUEST';
type SI_CHECK_THEME_STATUS_REQUEST_TYPE = 'SI_CHECK_THEME_STATUS_REQUEST';

export const SI_CHECK_THEME_STATUS_SUCCESS = 'SI_CHECK_THEME_STATUS_SUCCESS';
type SI_CHECK_THEME_STATUS_SUCCESS_TYPE = 'SI_CHECK_THEME_STATUS_SUCCESS';

export const SI_CHECK_THEME_STATUS_FAILURE = 'SI_CHECK_THEME_STATUS_FAILURE';
type SI_CHECK_THEME_STATUS_FAILURE_TYPE = 'SI_CHECK_THEME_STATUS_FAILURE';

type SIThemeIntegrationFailure = {
  error: any
};

type SICheckThemeStatusRequestAction = Action<SI_CHECK_THEME_STATUS_REQUEST_TYPE, null>;

type SICheckThemeStatusSuccessAction = Action<
  SI_CHECK_THEME_STATUS_SUCCESS_TYPE,
  { data: ThemesType }
>;

type SICheckThemeStatusFailureAction = Action<
  SI_CHECK_THEME_STATUS_FAILURE_TYPE,
  SIThemeIntegrationFailure
>;

// Theme integration setup
export const SI_THEME_INTEGRATION_SETUP_REQUEST = 'SI_THEME_INTEGRATION_SETUP_REQUEST';
type SI_THEME_INTEGRATION_SETUP_REQUEST_TYPE = 'SI_THEME_INTEGRATION_SETUP_REQUEST';

export const SI_THEME_INTEGRATION_SETUP_SUCCESS = 'SI_THEME_INTEGRATION_SETUP_SUCCESS';
type SI_THEME_INTEGRATION_SETUP_SUCCESS_TYPE = 'SI_THEME_INTEGRATION_SETUP_SUCCESS';

export const SI_THEME_INTEGRATION_SETUP_FAILURE = 'SI_THEME_INTEGRATION_SETUP_FAILURE';
type SI_THEME_INTEGRATION_SETUP_FAILURE_TYPE = 'SI_THEME_INTEGRATION_SETUP_FAILURE';

type SIThemeIntegrationSetupRequestAction = Action<SI_THEME_INTEGRATION_SETUP_REQUEST_TYPE, null>;

type SIThemeIntegrationSetupSuccessAction = Action<
  SI_THEME_INTEGRATION_SETUP_SUCCESS_TYPE,
  { data: ThemesType }
>;

type SIThemeIntegrationSetupFailureAction = Action<
  SI_THEME_INTEGRATION_SETUP_FAILURE_TYPE,
  SIThemeIntegrationFailure
>;

// Theme integration upgrade
export const SI_THEME_INTEGRATION_UPGRADE_REQUEST = 'SI_THEME_INTEGRATION_UPGRADE_REQUEST';
type SI_THEME_INTEGRATION_UPGRADE_REQUEST_TYPE = 'SI_THEME_INTEGRATION_UPGRADE_REQUEST';

export const SI_THEME_INTEGRATION_UPGRADE_SUCCESS = 'SI_THEME_INTEGRATION_UPGRADE_SUCCESS';
type SI_THEME_INTEGRATION_UPGRADE_SUCCESS_TYPE = 'SI_THEME_INTEGRATION_UPGRADE_SUCCESS';

export const SI_THEME_INTEGRATION_UPGRADE_FAILURE = 'SI_THEME_INTEGRATION_UPGRADE_FAILURE';
type SI_THEME_INTEGRATION_UPGRADE_FAILURE_TYPE = 'SI_THEME_INTEGRATION_UPGRADE_FAILURE';

type SIThemeIntegrationUpgradeRequestAction = Action<
  SI_THEME_INTEGRATION_UPGRADE_REQUEST_TYPE,
  null
>;

type SIThemeIntegrationUpgradeSuccessAction = Action<
  SI_THEME_INTEGRATION_UPGRADE_SUCCESS_TYPE,
  { data: ThemesType }
>;

type SIThemeIntegrationUpgradeFailureAction = Action<
  SI_THEME_INTEGRATION_UPGRADE_FAILURE_TYPE,
  SIThemeIntegrationFailure
>;

export const SI_THEME_INTEGRATION_SETTINGS_REQUEST = 'SI_THEME_INTEGRATION_SETTINGS_REQUEST';
type SI_THEME_INTEGRATION_SETTINGS_REQUEST_TYPE = 'SI_THEME_INTEGRATION_SETTINGS_REQUEST';

export const SI_THEME_INTEGRATION_SETTINGS_SUCCESS = 'SI_THEME_INTEGRATION_SETTINGS_SUCCESS';
type SI_THEME_INTEGRATION_SETTING_SUCCESS_TYPE = 'SI_THEME_INTEGRATION_SETTING_SUCCESS_TYPE';

export const SI_THEME_INTEGRATION_SETTINGS_FAILURE = 'SI_THEME_INTEGRATION_SETTINGS_FAILURE';
type SI_THEME_INTEGRATION_SETTINGS_FAILURE_TYPE = 'SI_THEME_INTEGRATION_SETTINGS_FAILURE';

type SIThemeIntegrationSettingsRequestAction = Action<
  SI_THEME_INTEGRATION_SETTINGS_REQUEST_TYPE,
  null
>;

type SIThemeIntegrationSettingsSuccessAction = Action<
  SI_THEME_INTEGRATION_SETTING_SUCCESS_TYPE,
  { data: ThemesType }
>;

type SIThemeIntegrationSettingsFailureAction = Action<
  SI_THEME_INTEGRATION_SETTINGS_FAILURE_TYPE,
  SIThemeIntegrationFailure
>;

export const SI_THEME_INTEGRATION_UPDATE_FIELD = `SI_THEME_INTEGRATION_UPDATE_FIELD`;
type SI_THEME_INTEGRATION_UPDATE_FIELD_TYPE = 'SI_THEME_INTEGRATION_UPDATE_FIELD';
type SIThemeIntegrationUpdateFieldAction = Action<SI_THEME_INTEGRATION_UPDATE_FIELD_TYPE, any>;

export const SI_THEME_INTEGRATION_UPDATE_MULTI_FIELDS = 'SI_THEME_INTEGRATION_UPDATE_MULTI_FIELDS';
type SI_THEME_INTEGRATION_UPDATE_MULTI_FIELDS_TYPE = 'SI_THEME_INTEGRATION_UPDATE_MULTI_FIELDS';
type SIThemeIntegrationUpdateMultiFieldsAction = Action<
  SI_THEME_INTEGRATION_UPDATE_MULTI_FIELDS_TYPE,
  any
>;

// Theme integration feature
export const SI_THEME_INTEGRATION_FEATURE_REQUEST = 'SI_THEME_INTEGRATION_FEATURE_REQUEST';
type SI_THEME_INTEGRATION_FEATURE_REQUEST_TYPE = 'SI_THEME_INTEGRATION_FEATURE_REQUEST';

export const SI_THEME_INTEGRATION_FEATURE_SUCCESS = 'SI_THEME_INTEGRATION_FEATURE_SUCCESS';
type SI_THEME_INTEGRATION_FEATURE_SUCCESS_TYPE = 'SI_THEME_INTEGRATION_FEATURE_SUCCESS';

export const SI_THEME_INTEGRATION_FEATURE_FAILURE = 'SI_THEME_INTEGRATION_FEATURE_FAILURE';
type SI_THEME_INTEGRATION_FEATURE_FAILURE_TYPE = 'SI_THEME_INTEGRATION_FEATURE_FAILURE';

type SIThemeIntegrationFeatureRequestAction = Action<
  SI_THEME_INTEGRATION_FEATURE_REQUEST_TYPE,
  null
>;

type SIThemeIntegrationFeatureSuccessAction = Action<
  SI_THEME_INTEGRATION_FEATURE_SUCCESS_TYPE,
  { data: any }
>;

type SIThemeIntegrationFeatureFailureAction = Action<
  SI_THEME_INTEGRATION_FEATURE_FAILURE_TYPE,
  SIThemeIntegrationFailure
>;

// Theme integration simplify
export const SI_THEME_INTEGRATION_SIMPLIFY_REQUEST = 'SI_THEME_INTEGRATION_SIMPLIFY_REQUEST';
type SI_THEME_INTEGRATION_SIMPLIFY_REQUEST_TYPE = 'SI_THEME_INTEGRATION_SIMPLIFY_REQUEST';

export const SI_THEME_INTEGRATION_SIMPLIFY_SUCCESS = 'SI_THEME_INTEGRATION_SIMPLIFY_SUCCESS';
type SI_THEME_INTEGRATION_SIMPLIFY_SUCCESS_TYPE = 'SI_THEME_INTEGRATION_SIMPLIFY_SUCCESS';

export const SI_THEME_INTEGRATION_SIMPLIFY_FAILURE = 'SI_THEME_INTEGRATION_SIMPLIFY_FAILURE';
type SI_THEME_INTEGRATION_SIMPLIFY_FAILURE_TYPE = 'SI_THEME_INTEGRATION_SIMPLIFY_FAILURE';

type SIThemeIntegrationSimplifyRequestAction = Action<
  SI_THEME_INTEGRATION_SIMPLIFY_REQUEST_TYPE,
  null
>;

type SIThemeIntegrationSimplifySuccessAction = Action<
  SI_THEME_INTEGRATION_SIMPLIFY_SUCCESS_TYPE,
  { data: any }
>;

type SIThemeIntegrationSimplifyFailureAction = Action<
  SI_THEME_INTEGRATION_SIMPLIFY_FAILURE_TYPE,
  SIThemeIntegrationFailure
>;

// Theme integration simplify change features
export const SI_THEME_INTEGRATION_SIMPLIFY_CHANGE_FEATURES_REQUEST =
  'SI_THEME_INTEGRATION_SIMPLIFY_CHANGE_FEATURES_REQUEST';
type SI_THEME_INTEGRATION_SIMPLIFY_CHANGE_FEATURES_REQUEST_TYPE =
  'SI_THEME_INTEGRATION_SIMPLIFY_CHANGE_FEATURES_REQUEST';

export const SI_THEME_INTEGRATION_SIMPLIFY_CHANGE_FEATURES_SUCCESS =
  'SI_THEME_INTEGRATION_SIMPLIFY_CHANGE_FEATURES_SUCCESS';
type SI_THEME_INTEGRATION_SIMPLIFY_CHANGE_FEATURES_SUCCESS_TYPE =
  'SI_THEME_INTEGRATION_SIMPLIFY_CHANGE_FEATURES_SUCCESS';

export const SI_THEME_INTEGRATION_SIMPLIFY_CHANGE_FEATURES_FAILURE =
  'SI_THEME_INTEGRATION_SIMPLIFY_CHANGE_FEATURES_FAILURE';
type SI_THEME_INTEGRATION_SIMPLIFY_CHANGE_FEATURES_FAILURE_TYPE =
  'SI_THEME_INTEGRATION_SIMPLIFY_CHANGE_FEATURES_FAILURE';

type SIThemeIntegrationSimplifyChangeFeaturesRequestAction = Action<
  SI_THEME_INTEGRATION_SIMPLIFY_CHANGE_FEATURES_REQUEST_TYPE,
  null
>;

type SIThemeIntegrationSimplifyChangeFeaturesSuccessAction = Action<
  SI_THEME_INTEGRATION_SIMPLIFY_CHANGE_FEATURES_SUCCESS_TYPE,
  { data: any }
>;

type SIThemeIntegrationSimplifyChangeFeaturesFailureAction = Action<
  SI_THEME_INTEGRATION_SIMPLIFY_CHANGE_FEATURES_FAILURE_TYPE,
  SIThemeIntegrationFailure
>;

// Upgrade to Turbo
export const SI_THEME_INTEGRATION_CREATE_TEMPLATE_INSTANCE_FROM_THEME_SETTINGS_REQUEST =
  'SI_THEME_INTEGRATION_CREATE_TEMPLATE_INSTANCE_FROM_THEME_SETTINGS_REQUEST';
type SI_THEME_INTEGRATION_CREATE_TEMPLATE_INSTANCE_FROM_THEME_SETTINGS_REQUEST_TYPE =
  'SI_THEME_INTEGRATION_CREATE_TEMPLATE_INSTANCE_FROM_THEME_SETTINGS_REQUEST';

export const SI_THEME_INTEGRATION_CREATE_TEMPLATE_INSTANCE_FROM_THEME_SETTINGS_SUCCESS =
  'SI_THEME_INTEGRATION_CREATE_TEMPLATE_INSTANCE_FROM_THEME_SETTINGS_SUCCESS';

type SI_THEME_INTEGRATION_CREATE_TEMPLATE_INSTANCE_FROM_THEME_SETTINGS_SUCCESS_TYPE =
  'SI_THEME_INTEGRATION_CREATE_TEMPLATE_INSTANCE_FROM_THEME_SETTINGS_SUCCESS';

export const SI_THEME_INTEGRATION_CREATE_TEMPLATE_INSTANCE_FROM_THEME_SETTINGS_FAILURE =
  'SI_THEME_INTEGRATION_CREATE_TEMPLATE_INSTANCE_FROM_THEME_SETTINGS_FAILURE';

type SI_THEME_INTEGRATION_CREATE_TEMPLATE_INSTANCE_FROM_THEME_SETTINGS_FAILURE_TYPE =
  'SI_THEME_INTEGRATION_CREATE_TEMPLATE_INSTANCE_FROM_THEME_SETTINGS_FAILURE';

type SIThemeIntegrationCreateTemplateInstanceFromThemeSettingsRequestAction = Action<
  SI_THEME_INTEGRATION_CREATE_TEMPLATE_INSTANCE_FROM_THEME_SETTINGS_REQUEST_TYPE,
  { themeId: string }
>;

type SIThemeIntegrationCreateTemplateInstanceFromThemeSettingsSuccessAction = Action<
  SI_THEME_INTEGRATION_CREATE_TEMPLATE_INSTANCE_FROM_THEME_SETTINGS_SUCCESS_TYPE,
  { data: any }
>;

type SIThemeIntegrationCreateTemplateInstanceFromThemeSettingsFailureAction = Action<
  SI_THEME_INTEGRATION_CREATE_TEMPLATE_INSTANCE_FROM_THEME_SETTINGS_FAILURE_TYPE,
  any
>;

// Upgrade-to-turbo
export const SI_THEME_INTEGRATION_UPGRADE_TO_TURBO_REQUEST =
  'SI_THEME_INTEGRATION_UPGRADE_TO_TURBO_REQUEST';
type SI_THEME_INTEGRATION_UPGRADE_TO_TURBO_REQUEST_TYPE =
  'SI_THEME_INTEGRATION_UPGRADE_TO_TURBO_REQUEST';

export const SI_THEME_INTEGRATION_UPGRADE_TO_TURBO_SUCCESS =
  'SI_THEME_INTEGRATION_UPGRADE_TO_TURBO_SUCCESS';
type SI_THEME_INTEGRATION_UPGRADE_TO_TURBO_SUCCESS_TYPE =
  'SI_THEME_INTEGRATION_UPGRADE_TO_TURBO_SUCCESS';

export const SI_THEME_INTEGRATION_UPGRADE_TO_TURBO_FAILURE =
  'SI_THEME_INTEGRATION_UPGRADE_TO_TURBO_FAILURE';
type SI_THEME_INTEGRATION_UPGRADE_TO_TURBO_FAILURE_TYPE =
  'SI_THEME_INTEGRATION_UPGRADE_TO_TURBO_FAILURE';

export const SI_THEME_INTEGRATION_UPGRADE_TO_TURBO_CLEAN_UP =
  'SI_THEME_INTEGRATION_UPGRADE_TO_TURBO_CLEAN_UP';
type SI_THEME_INTEGRATION_UPGRADE_TO_TURBO_CLEAN_UP_TYPE =
  'SI_THEME_INTEGRATION_UPGRADE_TO_TURBO_CLEAN_UP';

type SIThemeIntegrationUpgradeToTurboRequestAction = Action<
  SI_THEME_INTEGRATION_UPGRADE_TO_TURBO_REQUEST_TYPE,
  { themeId: String }
>;

type SIThemeIntegrationUpgradeToTurboSuccessAction = Action<
  SI_THEME_INTEGRATION_UPGRADE_TO_TURBO_SUCCESS_TYPE,
  { data: any }
>;

type SIThemeIntegrationUpgradeToTurboFailureAction = Action<
  SI_THEME_INTEGRATION_UPGRADE_TO_TURBO_FAILURE_TYPE,
  SIThemeIntegrationFailure
>;

type SIThemeIntegrationUpgradeToTurboCleanUpAction = Action<
  SI_THEME_INTEGRATION_UPGRADE_TO_TURBO_CLEAN_UP_TYPE,
  { themeId?: String }
>;

// Theme integration simplify
export const SI_CHECK_LIVE_THEME_TURBO_REQUEST = 'SI_CHECK_LIVE_THEME_TURBO_REQUEST';
type SI_CHECK_LIVE_THEME_TURBO_REQUEST_TYPE = 'SI_CHECK_LIVE_THEME_TURBO_REQUEST';

export const SI_CHECK_LIVE_THEME_TURBO_SUCCESS = 'SI_CHECK_LIVE_THEME_TURBO_SUCCESS';
type SI_CHECK_LIVE_THEME_TURBO_SUCCESS_TYPE = 'SI_CHECK_LIVE_THEME_TURBO_SUCCESS';

export const SI_CHECK_LIVE_THEME_TURBO_FAILURE = 'SI_CHECK_LIVE_THEME_TURBO_FAILURE';
type SI_CHECK_LIVE_THEME_TURBO_FAILURE_TYPE = 'SI_CHECK_LIVE_THEME_TURBO_FAILURE';

type SICheckLiveThemeTurboRequestAction = Action<SI_CHECK_LIVE_THEME_TURBO_REQUEST_TYPE, null>;

type SICheckLiveThemeTurboSuccessAction = Action<
  SI_CHECK_LIVE_THEME_TURBO_SUCCESS_TYPE,
  { data: any }
>;

type SICheckLiveThemeTurboFailureAction = Action<
  SI_CHECK_LIVE_THEME_TURBO_FAILURE_TYPE,
  SIThemeIntegrationFailure
>;

export type SIThemeIntegrationAction =
  | SICheckThemeStatusRequestAction
  | SICheckThemeStatusSuccessAction
  | SICheckThemeStatusFailureAction
  | SIThemeIntegrationSetupRequestAction
  | SIThemeIntegrationSetupSuccessAction
  | SIThemeIntegrationSetupFailureAction
  | SIThemeIntegrationUpgradeRequestAction
  | SIThemeIntegrationUpgradeSuccessAction
  | SIThemeIntegrationUpgradeFailureAction
  | SIThemeIntegrationSettingsRequestAction
  | SIThemeIntegrationSettingsSuccessAction
  | SIThemeIntegrationSettingsFailureAction
  | SIThemeIntegrationUpdateFieldAction
  | SIThemeIntegrationUpdateMultiFieldsAction
  | SIThemeIntegrationFeatureRequestAction
  | SIThemeIntegrationFeatureSuccessAction
  | SIThemeIntegrationFeatureFailureAction
  | SIThemeIntegrationSimplifyRequestAction
  | SIThemeIntegrationSimplifySuccessAction
  | SIThemeIntegrationSimplifyFailureAction
  | SIThemeIntegrationEnableBoostCoreRequestAction
  | SIThemeIntegrationEnableBoostCoreSuccessAction
  | SIThemeIntegrationEnableBoostCoreFailureAction
  | SIThemeIntegrationSimplifyChangeFeaturesRequestAction
  | SIThemeIntegrationSimplifyChangeFeaturesSuccessAction
  | SIThemeIntegrationSimplifyChangeFeaturesFailureAction
  | SIThemeIntegrationCreateTemplateInstanceFromThemeSettingsRequestAction
  | SIThemeIntegrationCreateTemplateInstanceFromThemeSettingsSuccessAction
  | SIThemeIntegrationCreateTemplateInstanceFromThemeSettingsFailureAction
  | SIThemeIntegrationUpgradeToTurboRequestAction
  | SIThemeIntegrationUpgradeToTurboSuccessAction
  | SIThemeIntegrationUpgradeToTurboFailureAction
  | SIThemeIntegrationUpgradeToTurboCleanUpAction
  | SICheckLiveThemeTurboRequestAction
  | SICheckLiveThemeTurboSuccessAction
  | SICheckLiveThemeTurboFailureAction;

export type SIThemeIntegrationState = {
  checkingTheme: boolean,
  checkingThemeSuccess: boolean,
  templateInstance: Record<String, any>,

  // Theme integration setup
  integratingTheme: boolean,
  integratingThemeSuccess: boolean,
  createdTemplateInstance: Record<String, any>,

  // Theme integration upgrade
  upgradingTheme: boolean,
  upgradingThemeSuccess: boolean,
  upgradedTemplateInstance: Record<String, any>,

  themeSettings: Record<string, any>,

  upgradeThemeToTurbo: {
    themeId: string,
    status: 'idle' | 'pending' | 'success' | 'failure',
    templateInstance: unknown
  },
  isLiveThemeIntegratedTurbo: boolean
};

export interface ParamsSetupSimplify {
  themeName: string;
  role: string;
  features: {
    collectionPage: boolean,
    searchPage: boolean,
    isw: boolean
  };
  autoEnableBoostCore?: boolean;
}

export interface ParamsUpdateFeatures {
  collectionPage: boolean;
  searchPage: boolean;
  isw: boolean;
}

export const SEND_REQUEST_NEW_INTEGRATION_TO_SLACK = 'SEND_REQUEST_NEW_INTEGRATION_TO_SLACK';
export const SEND_REQUEST_NEW_INTEGRATION_TO_SLACK_SUCCESS =
  'SEND_REQUEST_NEW_INTEGRATION_TO_SLACK_SUCCESS';
export const SEND_REQUEST_NEW_INTEGRATION_TO_SLACK_FAILURE =
  'SEND_REQUEST_NEW_INTEGRATION_TO_SLACK_FAILURE';
